export default __webpack_public_path__ + "static/media/20.d0ae0d55.jpg";